import styled, { createGlobalStyle } from "styled-components";

export const PlotlyStyles = createGlobalStyle`
  .js-plotly-plot {
    position: relative;
  }
  .plotly .tooltip {
    position: absolute;
    z-index: 1000;
  }
  .plotly .modebar {
    position: absolute;
    top: 2px;
    right: 2px;
  }
  .plotly .modebar--hover {
    opacity: 0;
    transition: opacity 0.3s ease 0s;
  }
  .plotly:hover .modebar--hover {
    opacity: 1;
  }
  .plotly .modebar-group {
    float: left;
    display: inline-block;
    box-sizing: border-box;
    margin-left: 8px;
    position: relative;
    vertical-align: middle;
    white-space: nowrap;
  }
  .plotly .modebar-btn {
    position: relative;
    font-size: 16px;
    padding: 3px 4px;
    cursor: pointer;
    line-height: normal;
    box-sizing: border-box;
  }
  .plotly .svg-container {
    position: relative;
    display: inline-block;
  }
  .plotly .main-svg {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
  }
  .plotly .plot-container {
    position: relative;
    display: inline-block;
    width: 100%;
  }
`;

export const StyledPlotlyChartContainer = styled.div`
    position: relative;
    width: 100%;
    overflow: auto;

    .js-plotly-plot {
        width: 100%;

        .plot-container {
            .modebar-group:last-child {
                display: none !important;
            }
        }
    }
`;
